function initAllFAQSections() {
  // Find all FAQ section wrappers that haven't been initialized yet
  const faqWrappers = document.querySelectorAll('.flex-container.page-width--inner:not([data-initialized])');

  faqWrappers.forEach(wrapper => {
    const headers = wrapper.querySelectorAll('.faq-section-header');
    
    // Skip if this isn't an FAQ section
    if (!headers.length) return;

    // Mark as initialized to prevent double-firing during Theme Editor saves
    wrapper.setAttribute('data-initialized', 'true');

    const navLinks = wrapper.querySelectorAll('.faq-nav-link');
    const mobileSelect = wrapper.querySelector('.faq-mobile-select');

    // 1. Jump to section when mobile dropdown is changed
    if (mobileSelect) {
      mobileSelect.addEventListener('change', function(e) {
        const targetId = e.target.value;
        // Scope the query strictly to this specific wrapper
        const targetElement = wrapper.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // 2. Intersection Observer to watch scrolling
    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px -60% 0px', // Triggers when header is in the upper middle of the screen
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          
          // Update Desktop Sidebar active class
          if (navLinks.length) {
            navLinks.forEach(link => link.classList.remove('active'));
            const activeLink = wrapper.querySelector(`.faq-nav-link[href="#${id}"]`);
            if (activeLink) {
              activeLink.classList.add('active');
            }
          }
          
          // Update Mobile Dropdown selected value
          if (mobileSelect) {
            mobileSelect.value = `#${id}`;
          }
        }
      });
    }, observerOptions);

    headers.forEach(header => observer.observe(header));
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initAllFAQSections);

// Re-initialize if the section is added/edited in the Shopify Theme Editor
document.addEventListener('shopify:section:load', () => {
  setTimeout(initAllFAQSections, 50);
});